import React from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';

/**
 * Confirmation dialog for deleting a chat project and all of its chats.
 */
const DeleteProjectDialog = ({
  open,
  project,
  isDarkMode,
  deleting,
  error,
  onCancel,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={() => {
      if (!deleting) onCancel();
    }}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: '16px',
        bgcolor: isDarkMode ? '#2f2f2f' : '#ffffff',
        backgroundImage: 'none',
      },
    }}
  >
    <DialogTitle sx={{ color: isDarkMode ? 'white' : 'black', pb: 1 }}>
      Delete this project?
    </DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ color: 'gray', mb: 1.5 }}>
        This will permanently delete the project and all chats inside it. This
        action cannot be undone.
      </Typography>
      {project?.name && (
        <Box
          sx={{
            px: 1.5,
            py: 1,
            borderRadius: '10px',
            bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.04)',
          }}
        >
          <Typography
            sx={{
              fontSize: '0.9rem',
              fontWeight: 500,
              color: isDarkMode ? 'white' : 'black',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {project.name}
          </Typography>
        </Box>
      )}
      {error && (
        <Typography
          variant="body2"
          sx={{ color: '#e57373', mt: 1.5, fontSize: '0.85rem' }}
          role="alert"
        >
          {error}
        </Typography>
      )}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onCancel} disabled={deleting}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        disabled={deleting}
        sx={{
          bgcolor: '#d32f2f',
          color: '#fff',
          '&:hover': { bgcolor: '#b71c1c' },
          '&.Mui-disabled': {
            bgcolor: isDarkMode ? 'rgba(211,47,47,0.4)' : 'rgba(211,47,47,0.5)',
            color: 'rgba(255,255,255,0.7)',
          },
        }}
      >
        {deleting ? (
          <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            <CircularProgress size={14} sx={{ color: '#fff' }} />
            Deleting…
          </Box>
        ) : (
          'Delete project'
        )}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteProjectDialog;
